// extracted by mini-css-extract-plugin
export var authorBioEditorialAbout = "J_b9";
export var authorBioEditorialContainer = "J_b8";
export var authorBioEditorialXp = "J_cb";
export var authorBioPageContainer = "J_b7";
export var relatedArticles = "J_x";